import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import styles from './style/product_card_style.module.scss'
import Typography from '../../foundations/typography/Typography'
import Foundation from '../../foundations/Foundation'
import Translation from '../../../global/Translation'
import Tabs from '../../basics/tabs/Tabs'
import Separator from '../../foundations/separator/Separator'
import Button from '../../basics/button/Button'
import { injectIntl } from 'react-intl'
import { REPO_STONES_FAMILIES } from '../../../natural-stone/NaturalStoneHelper'
import PnDisplayPrice from '../../../natural-stone/display-prices/PnDisplayPrice'
import LocalizedLink from '../../../global/LocalizedLink'
import { connect } from 'react-redux'
import { getLanguageDir } from '../../../../store/ui/reducers'

const ProductCard = ({ className = '', footerClass = '', style = {}, colors, fit, click, ...props }) => {


    //Con esta implementación los materiales y las relaciones entre el grosor y el acabado están completamente acoplados
    //a la estructura de datos que se obtiene del repositorio.
    const [thicknessTabs, setThicknessTabs] = React.useState()
    const [finishTabs, setFinishTabs] = React.useState()
    const [selectedThickness, setSelectedThickness] = React.useState(Object.keys(colors.relations.thickness)[0])
    const [selectedFinish, setSelectedFinish] = React.useState(Object.keys(colors.relations.finish)[0])
    const [currentProduct, setCurrentProduct] = React.useState(colors.innerHits[0])

    useEffect(() => {
        const finishIndex = colors.relations.thickness[selectedThickness].indexOf(selectedFinish)
        const thicknessIndex = colors.relations.finish[selectedFinish].indexOf(selectedThickness)
        const thicknessTabs = (
            <Tabs
                className={styles['product-card-tabs']}
                type="chip"
                selected={thicknessIndex}
                tabs={ colors.relations.finish[selectedFinish].map(thickness => {
                    return {label: thickness, onClick: (e)=> setSelectedThickness(thickness)}
                })}
            />
        )
        const finishTabs = (
            <Tabs
                className={styles['product-card-tabs']}
                type="chip"
                selected={finishIndex}
                tabs={ colors.relations.thickness[selectedThickness].map(finish => {
                    return {label: props.intl.formatMessage({id:finish}), onClick: ()=> setSelectedFinish(finish)}
                })}
            />
        )
        setThicknessTabs(thicknessTabs)
        setFinishTabs(finishTabs)

        const currentProduct = colors.innerHits.find(product => {
            return product.finish === selectedFinish && product.thickness === selectedThickness
        })
        setCurrentProduct(currentProduct)
    }, [selectedThickness, selectedFinish])

    useEffect(() => {
        props.updateProduct && props.updateProduct(props.index, currentProduct)
    }, [currentProduct])


    return currentProduct ? (
        <Foundation neutral-900>
            <div className={`${styles['product-card']} ${className}`} style={style}>
                <div className={`${styles['product-card-image-container']} ${fit && styles.fit}`}>
                    <img src={colors.imgFull} alt={`${colors.displayName} image`} className={styles['product-card-image']} width="100%" />
                </div>

                <div className={styles['product-card-title']}>
                    <Typography typeface="title-l-medium">{colors.displayName.toLowerCase()}</Typography>
                    <Typography typeface="title-s-light" neutral-600>
                        {`${props.intl.formatMessage({ id: REPO_STONES_FAMILIES[colors.family] })} - ${colors.brand.toLowerCase()}®`}
                    </Typography>
                </div>

                <div className={styles['product-card-filters']}>
                    <div>
                        <div className={styles['product-card-filter']}>
                            <Typography typeface="body-xs-light" block>
                                <Translation id="thickness" defaultMessage="Thickness" />
                            </Typography>
                            <Typography typeface="body-xs-light" block>
                                {thicknessTabs}
                            </Typography>
                        </div>

                        <div className={styles['product-card-filter']}>
                            <Typography typeface="body-xs-light" block>
                                <Translation id="finish" defaultMessage="Finish" />
                            </Typography>
                            <Typography typeface="body-xs-light" block>
                                {finishTabs}
                            </Typography>
                        </div>
                    </div>
                    <Separator neutral-900 />
                </div>
                <div className={`${styles['product-card-footer']} ${footerClass}`}>
                    <PnDisplayPrice product={currentProduct} showPriceDiscountDisclaimer={false} />
                    {currentProduct.stock > 0 ? (
                        <LocalizedLink
                            // target="_blank"
                            routeId="ROUTE_LOT_PRODUCT_IMAGE_VIEWER"
                            params={{
                                parentUrl: window.location.href,
                                productId: currentProduct.productId,
                                center: props.centerId,
                                outlet: ''
                            }}
                            gtmLabel="ec_lupa"
                        >
                            <Button
                                style-black
                                size-m
                                onClick={() => {
                                    console.log('CLICK', props)
                                    click(currentProduct, props.list, props.index)
                                }}
                                img={props.languageDir === 'rtl' ? "arrow_short_inverse" : "arrow_short"}
                                hImg={props.languageDir === 'rtl' ? "arrow_large_inverse" : "arrow_large"}
                            >
                                <Translation id="choose_lot" defaultMessage="Choose lot" />
                            </Button>
                        </LocalizedLink>
                    ) : (
                        <LocalizedLink
                            // target="_blank"
                            routeId="ROUTE_PRODUCT_DETAIL"
                            params={{
                                parentUrl: window.location.href,
                                id: currentProduct.productId,
                                center: props.centerId,
                                outlet: ''
                            }}
                            gtmLabel="ec_lupa"
                        >
                            <Button
                                style-black
                                size-m
                                onClick={() => {
                                    console.log('CLICK', props)
                                    click(currentProduct, props.list, props.index)
                                }}
                                img={props.languageDir === 'rtl' ? "arrow_short_inverse" : "arrow_short"}
                                hImg={props.languageDir === 'rtl' ? "arrow_large_inverse" : "arrow_large"}
                            >
                                <Translation id="view_detail" defaultMessage="View detail" />
                            </Button>
                        </LocalizedLink>
                    )}
                </div>
            </div>
        </Foundation>
    ) : (
        ''
    )
};

const mapDispatchToProps = dispatch => {
    return {
        click: (product, list, index) => dispatch({ type: 'PRODUCT_CLICK', product, index, list})
    }
}

const mapStateToProps = (state) => {
    return {
        languageDir: getLanguageDir(state)
    }
}

ProductCard.propTypes = {
    colors: PropTypes.object.isRequired,
    fit: PropTypes.bool,
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ProductCard));